var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M20 2a2 2 0 0 1 1.995 1.85L22 4v16a2 2 0 0 1-1.85 1.995L20 22H4a2 2 0 0 1-1.995-1.85L2 20V4a2 2 0 0 1 1.85-1.995L4 2zM8 10H4v10h4zm12 0H10v10h10zm0-6H4v4h16z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }